import * as React from 'react';
import { ReleaseNav, ReleaseStepType } from '../../types';
import { StringKeyedDictionary } from '../../typescriptHelpers';
import * as Storage from '../../helpers/localStorageHelper';

const useSetLastViewedReleaseStep: (
    releaseId: string,
    page: ReleaseNav | ReleaseStepType | string,
    deps?: React.DependencyList,
) => void = (releaseId, page, deps = []) => {
    React.useEffect(() => {
        const currentValue: StringKeyedDictionary<string> =
            Storage.getItem(Storage.LAST_VIEWED_RELEASE_STEP_FOR_RELEASE) ?? {};

        const updatedValue = {
            ...currentValue,
            [releaseId]: page,
        };

        Storage.setItem(Storage.LAST_VIEWED_RELEASE_STEP_FOR_RELEASE, updatedValue);
    }, [...deps]);

    return null;
};

export default useSetLastViewedReleaseStep;
